export const REACT_APP_API_URL     = process.env.REACT_APP_API_URL
export const REACT_APP_CLOUD_FRONT = process.env.REACT_APP_CLOUD_FRONT

export const serviceFeePercent = Number(process.env.REACT_APP_SERVICE_FEE_PERCENT) ?? 12

const PRODUCTION_API_HOST = 'api.jdicentral.com'

const apiHostname = (() => {
  try { return new URL(REACT_APP_API_URL ?? '').hostname } catch { return '' }
})()

export const isProductionEnv = apiHostname === PRODUCTION_API_HOST
